export default {
  moderationAll: [],
  moderationAir: [],
  moderationGround: [],
  moderationWater: []
}
